<template>
  <div>
    <sweet-modal blocking width="2000px" title="Apply Over Payments Summary" ref="applyOverPayments" v-on:close="closeModal">
      <el-row :gutter="20">
        <el-col :span="24" :offset="0">
          <el-table
            :data="tableData"
            border
            size="mini"
            style="width: 100%">
            <el-table-column
              prop="crid"
              label="CR ID"
              width="120"
              align="center">
            </el-table-column>
            <el-table-column
              prop="date"
              label="Date"
              align="center">
            </el-table-column>
            <el-table-column
              label="Over PMT Bal (Cr)"
              align="right">
              <template slot-scope="scope">
                <span>{{ formatPrice(scope.row.ovptcrdeff) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="Amt Applied"
              align="right">
              <template slot-scope="scope">
                <span>{{ formatPrice(scope.row.amtApplied) }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </sweet-modal>
  </div>
</template>

<script>
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue';
  let moment = require('moment')

  export default {
    name: 'Use Balance',
    props: {
      tableData: {
        type: Array,
        default: () => {
          return []
        }
      }
    },
    components: {
      SweetModal,
    },
    data() {
      return {
        moment: moment,
      }
    },
    computed: {
      totalAmtApplied() {
        return this.tableData.reduce((total, item) => {
          total += item.amtApplied
          return total
        }, 0)
      },
      totalOPTBal() {
        return this.tableData.reduce((total, item) => {
          total += item.overpmtcr
          return total
        }, 0)
      },
    },
    methods: {
      async open() {
        this.$refs.applyOverPayments.open()
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
      closeModal() {
        // this.form.text = ''
      },
    },
  }
</script>

<style lang="scss" scoped>
.item {
  font-size: 15px;
  display: flex;
  justify-content: space-between;
  // min-width: 260px;
  padding: 6px;
  // margin-bottom: 10px;
  border: 1px solid #a9a9b0;
  &.orange {
    background-color: #f5dab1;
    min-width: 260px;
    margin-left: auto;
  }
  &.success {
    background-color: #e1f3d8;
  }
  &.grey {
    background-color: #ebeef5;
  }
  &.bold {
    font-weight: bold;
  }
  &.dots {
    border: 1px dashed #a9a9b0;
  }
  &.prices {
    align-items: center;
    justify-content: center;
    text-align: center;
    min-width: 100px;
  }
  .num {
    min-width: 85px;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  }
  .tf-red {
    color: #F56C6C;
  }
  .tf-green {
    color: #50b944;
  }
}
/deep/.sweet-modal-overlay .sweet-modal {
  max-width: 1300px !important;
}
</style>